import { createContext } from "react";
import ChatSocketManager from "../libs/chatSocketManager";

const ChatSocketContext = createContext(null as ChatSocketManager);

export default ChatSocketContext;
